// src/constants.js
export const MODULE_MAP = {
  business: 'business',
  branding: 'branding',
  employees: 'employees',
  hours: 'hours',
  appointmentTypes: 'appointments',
  paymentSetup: 'api',
  discounts: 'discounts',
  taxSetup: 'taxes',
};
